import React, { useEffect } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { allowTransitionToSearchSection } from './utils';
import SearchResult from './SearchResult';
import { Loading } from './StyledComponents';
import { SearchPlaceholder } from './SearchPlaceholder';
import i18n from 'i18n';

const SEARCH_RESULT_AREA_STATES = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  DISPLAY: 'DISPLAY',
  NO_RESULTS: 'NO_RESULTS',
};

export const SearchResultArea = props => {
  const { isLoading, results, onItemEnter, onCategoryEnter, query } = props;
  const items = get(results, ['content']);
  let searchAreaResultAreaState = SEARCH_RESULT_AREA_STATES.IDLE;

  if (isLoading) {
    searchAreaResultAreaState = SEARCH_RESULT_AREA_STATES.LOADING;
  } else if (items) {
    searchAreaResultAreaState =
      items.length > 0 ? SEARCH_RESULT_AREA_STATES.DISPLAY : SEARCH_RESULT_AREA_STATES.NO_RESULTS;
  }

  const isSearchResultDisplayed = searchAreaResultAreaState === SEARCH_RESULT_AREA_STATES.DISPLAY;

  useEffect(() => {
    allowTransitionToSearchSection(isSearchResultDisplayed);
  }, [isSearchResultDisplayed]);

  switch (searchAreaResultAreaState) {
    case SEARCH_RESULT_AREA_STATES.LOADING:
      return <Loading />;

    case SEARCH_RESULT_AREA_STATES.DISPLAY:
      return (
        <SearchResult
          results={results}
          onItemEnter={onItemEnter}
          onCategoryEnter={onCategoryEnter}
        />
      );

    case SEARCH_RESULT_AREA_STATES.NO_RESULTS:
      return <SearchPlaceholder description={i18n.t('search.empty', { query })} />;

    case SEARCH_RESULT_AREA_STATES.IDLE:
    default:
      return <SearchPlaceholder description={i18n.t('search.placeholder')} />;
  }
};

SearchResultArea.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  results: PropTypes.shape({
    totalElements: PropTypes.number.isRequired,
    content: PropTypes.array.isRequired,
    previewItems: PropTypes.array.isRequired,
    previewItemsCount: PropTypes.number.isRequired,
  }),
  query: PropTypes.string.isRequired,
  onItemEnter: PropTypes.func.isRequired,
};
